import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useFilesUploadStore } from 'src/common/store/files-upload.store';
import { useWizardStore } from '../store';

export const WizardLoadingProgressBar = () => {
  const [amountForUploads, setAmountForUploads] = useState(0);
  const ongoingUploadLength = useFilesUploadStore((state) => state.stackLength);
  const initialOngoingUploadLengthRef = useRef(ongoingUploadLength);

  const progress = useWizardStore((state) => state.progress);
  const remainingProgressForUploadsRef = useRef((100 - progress) / 2);
  const progressAmountForUploadedRef = useRef(
    remainingProgressForUploadsRef.current / initialOngoingUploadLengthRef.current
  );

  const increaseProgress = useCallback((increaseAmount: number) => {
    setAmountForUploads((amount) => Math.min(amount + increaseAmount, 100));
  }, []);

  useEffect(() => {
    if (ongoingUploadLength < initialOngoingUploadLengthRef.current) {
      increaseProgress(progressAmountForUploadedRef.current);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ongoingUploadLength]);

  return (
    <div className='absolute top-0 inset-x-0 flex justify-center w-full'>
      <div className='relative flex flex-1 h-1 bg-transparent'>
        <div
          className='absolute left-0 flex h-full z-10 bg-bedrock-black'
          style={{ width: `${progress + amountForUploads}%`, transition: 'width 500ms' }}
        />
      </div>
    </div>
  );
};
